export const BaseDict = {
    FirstHalf: "H1",
    SecondHalf: "H2",
    Goal: "Goal",
    Corner: "Corner",
    Penalty: "Penalty",
    YellowCard: "Yellow Card",
    RedCard: "Red Card",
    MinAgo: "m ago",
    Now: "now",
    NoIncidentsMessage: "Currently there are no incidents"
};
//# sourceMappingURL=dict.js.map